import { render, staticRenderFns } from "./DaftarShift.vue?vue&type=template&id=ab1d06fa&scoped=true"
import script from "./DaftarShift.vue?vue&type=script&lang=js"
export * from "./DaftarShift.vue?vue&type=script&lang=js"
import style0 from "./DaftarShift.vue?vue&type=style&index=0&id=ab1d06fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab1d06fa",
  null
  
)

export default component.exports